import api from '../../api';

export const recordPortsStartRequest = () => {
  return {
    type: 'RECORD_PORTS_START_REQUEST'
  };
};

export const recordPortsEndRequest = () => {
  return {
    type: 'RECORD_PORTS_END_REQUEST'
  };
};

export const getAllRecordPortsSuccess = ({ data }) => {
  return {
    type: 'RECORD_PORTS_GET_ALL_SUCCESS',
    payload: data
  };
};

export const getAllRecordPortsError = error => {
  return {
    type: 'RECORD_PORTS_GET_ALL_ERROR',
    payload: error
  };
};

export const editRecordPortsSuccess = ({ data }) => {
  return {
    type: 'RECORD_PORTS_EDIT_SUCCESS',
    payload: data
  };
};

export const editRecordPortsError = error => {
  return {
    type: 'RECORD_PORTS_EDIT_ERROR',
    payload: error
  };
};

export const removeRecordPortsSuccess = id => {
  return {
    type: 'RECORD_PORTS_REMOVE_SUCCESS',
    payload: id
  };
};

export const removeRecordPortsError = error => {
  return {
    type: 'RECORD_PORTS_REMOVE_ERROR',
    payload: error
  };
};

export const getAllRecordPorts = (params = {}) => {
  return async dispatch => {
    try {
      dispatch(recordPortsStartRequest());
      const response = await api().get('/api/record_ports', { params });
      dispatch(getAllRecordPortsSuccess(response));
    } catch (err) {
      dispatch(getAllRecordPortsError(err));
    } finally {
      dispatch(recordPortsEndRequest());
    }
  };
};

export const editRecordPorts = (
  data,
  submitBtn,
  url = '/api/record_ports/'
) => {
  return async dispatch => {
    const defaultMsg = button => {
      return new Promise(resolve => {
        document
          .getElementsByClassName('page-content')[0]
          .scrollTo({ top: 0, left: 0, behavior: 'smooth' });
        setTimeout(() => {
          dispatch(recordPortsEndRequest());
          button.disabled = false;
          dispatch(getAllRecordPorts());
          resolve(true);
        }, 3500);
      });
    };

    try {
      submitBtn.disabled = true;
      dispatch(recordPortsStartRequest());
      const response = await api().put(url, data);
      dispatch(editRecordPortsSuccess(response));
      await defaultMsg(submitBtn);
    } catch (err) {
      dispatch(editRecordPortsError(err));
      await defaultMsg(submitBtn);
    }
  };
};

export const editRecordPortsIP = (data, submitBtn) => {
  return async dispatch =>
    dispatch(editRecordPorts(data, submitBtn, '/api/record_ports/ip'));
};

export const editRecordPortsAnalogic = (data, submitBtn) => {
  return async dispatch =>
    dispatch(editRecordPorts(data, submitBtn, '/api/record_ports/analogic'));
};

export const removeAnalogicRecordPorts = (data, formReset, submitBtn) => {
  return async dispatch => {
    const defaultMsg = button => {
      return new Promise(resolve => {
        formReset();
        document
          .getElementsByClassName('page-content')[0]
          .scrollTo({ top: 0, left: 0, behavior: 'smooth' });
        setTimeout(() => {
          dispatch(recordPortsEndRequest());
          button.disabled = false;
          dispatch(getAllRecordPorts());
          resolve(true);
        }, 1800);
      });
    };

    try {
      const id = data.voicePanel;
      submitBtn.disabled = true;
      dispatch(recordPortsStartRequest());
      const response = await api().delete('/api/record_ports/analogic/' + id);
      dispatch(removeRecordPortsSuccess(response));
      await defaultMsg(submitBtn);
    } catch (err) {
      dispatch(removeRecordPortsError(err));
      await defaultMsg(submitBtn);
    }
  };
};
